export const merchantInfoRouter = [
  {
    path: '/merchantInfo',
    name: 'merchantInfo',
    component: () => import('@/views/merchantInfo'),
    meta: {
      title: '商户信息',
      keepAlive: true
    }
  },
  {
    path: '/merchantInfo/basicInfo',
    name: 'basicInfo',
    component: () => import('@/views/merchantInfo/basicInfo'),
    meta: {
      title: '基本信息'
    }
  },
  {
    path: '/merchantInfo/signInfo',
    name: 'signInfo',
    component: () => import('@/views/merchantInfo/signInfo'),
    meta: {
      title: '签约信息'
    }
  },
  {
    path: '/merchantInfo/blocDetail',
    name: 'blocDetail',
    component: () => import('@/views/merchantInfo/blocDetail'),
    meta: {
      title: '所属集团'
    }
  },
  {
    path: '/merchantInfo/mchIdChange',
    name: 'mchIdChange',
    component: () => import('@/views/merchantInfo/mchIdChange'),
    meta: {
      title: '收款编号更换'
    }
  },
  {
    path: '/merchantInfo/merchantLimit',
    name: 'merchantLimit',
    component: () => import('@/views/merchantInfo/merchantLimit'),
    meta: {
      title: '额度信息'
    }
  },
  {
    path: '/merchantInfo/goldCardAmount/list',
    name: 'goldCardAmountList',
    component: () => import('@/views/merchantInfo/goldCardAmount/list'),
    meta: {
      title: '额度包查询',
      keepAlive: true
    }
  },
  {
    path: '/merchantInfo/goldCardAmount/detail',
    name: 'goldCardAmountDetail',
    component: () => import('@/views/merchantInfo/goldCardAmount/detail'),
    meta: {
      title: '额度包详情'
    }
  }
]
